import { render, staticRenderFns } from "./RESTDelete.vue?vue&type=template&id=ebff955e"
import script from "./RESTDelete.vue?vue&type=script&lang=js"
export * from "./RESTDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports